<template>
    <v-card>
        <v-card-title>Informations</v-card-title>

        <v-list>
            <v-list-item v-for="(item, i) in infosComputed" :key="i">
                <div class="d-flex">
                    <v-list-item-title style="max-width: 150px; flex: 0 0 150px">{{ item.title }}</v-list-item-title>
                    <v-list-item-subtitle>{{ item.value }}</v-list-item-subtitle>
                </div>
            </v-list-item>
        </v-list>
    </v-card>
</template>

<script>
export default {
    name: 'UserInfo',
    props: {
        user: { type: Object, required: true }
    },
    computed: {
        infosComputed() {
            return [
                { title: 'Matricule', value: this.user.matricule },
                { title: 'Prenom', value: this.user.prenom },
                { title: 'Nom', value: this.user.nom },
                /* { title: 'Email', value: this.user.email }, */
                { title: 'Profile', value: this.user.role },
                {
                    title: 'Etablissement',
                    value: this.user.etablissement_libelle ?? 'D.I.S.I.'
                }
            ];
        }
    }
};
</script>
